import React from 'react';

import { Button, Icon } from '@tf/ui';

import { TFErrorTemplate } from './TFErrorTemplate';

export const TFNotFoundRoute = () => {
	return (
		<TFErrorTemplate
			errorMessage={{
				icon: <Icon.IconError404 />,
				title: 'Page not found',
				description: 'Sorry, the page you were looking for was not found',
				primaryAction: (
					<Button
						leftSection={<Icon.IconHome size={24} />}
						component="a"
						variant="light"
						size="md"
						href="/"
						h={48}
						fz={16}
						fw={500}
					>
						Back to home page
					</Button>
				),
			}}
		/>
	);
};
